
/**
 * Generate contextual follow-up questions based on message content
 */
export const getSuggestionsBasedOnContent = (content: string): string[] => {
  // Default suggestions if we can't determine context
  const defaultSuggestions = [
    "Tell me more about the breakfast options",
    "What time is check-out?",
    "Are there any special events this week?",
    "How do I get to the nearest attractions?"
  ];
  
  const lowerContent = content.toLowerCase();
  
  // Generate contextual suggestions based on keywords in the content
  if (lowerContent.includes("breakfast") || lowerContent.includes("dining")) {
    return [
      "What time is breakfast served?",
      "Is room service available?",
      "Do you have vegetarian options?",
      "Are there restaurants nearby?"
    ];
  } else if (lowerContent.includes("pool") || lowerContent.includes("swim")) {
    return [
      "What are the pool hours?",
      "Do you have a lifeguard on duty?",
      "Are towels provided at the pool?",
      "Is there a hot tub or spa?"
    ];
  } else if (lowerContent.includes("checkout") || lowerContent.includes("check-out")) {
    return [
      "Can I request a late checkout?",
      "Is there luggage storage available?",
      "How do I settle my final bill?",
      "Can I get transportation to the airport?"
    ];
  } else if (lowerContent.includes("wifi") || lowerContent.includes("internet")) {
    return [
      "What's the wifi password?",
      "Is the wifi free for all guests?",
      "Does the wifi work in all areas of the hotel?",
      "Is there a business center I can use?"
    ];
  } else if (lowerContent.includes("gym") || lowerContent.includes("fitness")) {
    return [
      "What are the gym hours?",
      "Do you offer fitness classes?",
      "Is there an extra fee for the gym?",
      "Are there jogging trails nearby?"
    ];
  } else if (lowerContent.includes("attraction") || lowerContent.includes("visit") || lowerContent.includes("tour")) {
    return [
      "What attractions are within walking distance?",
      "Can the hotel arrange tours?",
      "What's the best way to get around the city?",
      "Are there any local events happening this week?"
    ];
  }
  
  return defaultSuggestions;
};
